import { Icon } from "@iconify/react";
import { useDispatch, useSelector } from "react-redux";
import {
  setSearch,
  clearFilters,
} from "../../store/frasesSeleccionAplicacion/frasesSeleccionAplicacion.reducer";
import SearchInput from "../UI/SearchInput";

const FrasesSeleccionAplicacionHeader = () => {
  const dispatch = useDispatch();
  const { search } = useSelector((state) => state.frasesSeleccionAplicacion);

  const handleSearchChange = (value) => {
    dispatch(setSearch(value));
  };

  const handleClearFilters = () => {
    dispatch(clearFilters());
  };

  return (
    <div className="mb-3">
      <div className="row g-2 align-items-center">
        <div className="col-12 col-md-auto">
          <h5 className="mb-0 fw-semibold text-center text-md-start">
            Frases de selección por aplicación
          </h5>
        </div>

        <div className="col-12 col-md">
          <div className="d-flex flex-column flex-sm-row gap-2 justify-content-md-end align-items-sm-center">
            <SearchInput
              value={search}
              onChange={handleSearchChange}
              placeholder="Buscar frases..."
              minChars={3}
              className="flex-grow-1"
            />

            {search && (
              <button
                onClick={handleClearFilters}
                className="btn btn-outline-secondary d-flex align-items-center gap-1"
                style={{ height: "44px" }}
                title="Limpiar búsqueda"
              >
                <Icon icon="mdi:filter-remove-outline" width="18" />
                <span className="d-none d-sm-inline">Limpiar</span>
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FrasesSeleccionAplicacionHeader;
